import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useAuth, useCart } from "../App";
import ProductCard from "../components/ProductCard";
import { Heart } from "lucide-react";
import { Button } from "../components/ui/button";

export default function Wishlist() {
  const { user, login, loading } = useAuth();
  const { wishlist } = useCart();

  useEffect(() => { if (!loading && !user) login(); }, [loading, user, login]);
  if (!user) return null;

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10" data-testid="wishlist-page">
      <h1 className="font-display text-4xl text-[#2C2A29] mb-2">Your Wishlist</h1>
      <p className="text-sm text-[#8A8480] mb-10">{wishlist.length} pieces saved with love</p>

      {wishlist.length === 0 ? (
        <div className="text-center py-20 bg-white border border-[#EAE3D9] rounded-2xl" data-testid="wishlist-empty">
          <Heart className="h-12 w-12 mx-auto text-[#C5A059] mb-4" />
          <p className="font-display text-2xl text-[#2C2A29]">Save your favourites here</p>
          <Link to="/products"><Button className="btn-primary mt-6 rounded-full px-6 py-5 h-auto">Explore jewellery</Button></Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5" data-testid="wishlist-grid">
          {wishlist.map(p => <ProductCard key={p.product_id} p={p} />)}
        </div>
      )}
    </div>
  );
}
